import { put, takeLatest, call } from 'redux-saga/effects';
import { httpCreators, HttpResponse } from 'rbh-merchant-core';
import { VAT_STATE_KEY } from './vat-reducer';
import { vatCreators } from './vat-action';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { VatService } from './vat-service';
import { VAT_REQUEST_ID_LIST } from './vat-constant';
import { generalSagas } from '../../../../redux/general/general-saga';

function* callVatAdd() {
  yield put(httpCreators.request({
    id: VAT_REQUEST_ID_LIST.GET_VAT,
    sagaHandler: getVatHandler as any,
    callbackParams: '',
    service: VatService.getVat,
    serviceParams: ''
  }));
  yield call(generalSagas.callTnc);
}

function* getVatHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(vatCreators.setVatState(VAT_STATE_KEY.LIST, resp.data.vatAddresses as []));
    if (resp.data.vatAddresses.length !== 0) {
      const content = {
        vatAddressName: resp.data.vatAddresses[0].vatAddressName,
        vatAddressTaxId: resp.data.vatAddresses[0].vatAddressTaxId
      };
      yield put(vatCreators.setVatState(VAT_STATE_KEY.PREFILL, content));
    }
  } else {
    yield put(vatCreators.setVatState(VAT_STATE_KEY.LIST, undefined));
  }
}

function* getVatAddHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    if (resp.data.vatAddresses.length !== 0) {
      const content = {
        vatAddressName: resp.data.vatAddresses[0].vatAddressName,
        vatAddressTaxId: resp.data.vatAddresses[0].vatAddressTaxId
      };
      yield put(vatCreators.setVatState(VAT_STATE_KEY.PREFILL, content));
    }
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams(); },
      type: MODAL_TYPE.ERROR,
      clickClosable: false,
      escClosable: false
    }));
  }
}

function* postVatHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams);
  } else if (resp.statusCode === 1899 && resp.data.translationKey === 'vatAddress.duplicatedHQ') {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContent: 'main.vat_error_duplicatedHQ',
      type: MODAL_TYPE.ERROR
    }));
  } else if (resp.statusCode === 1899 && resp.data.translationKey === 'vatAddress.duplicatedVatAddress') {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContent: 'main.vat_error_duplicatedVatAddress',
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchVatHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams);
  } else if (resp.statusCode === 1899 && resp.data.translationKey === 'vatAddress.duplicatedHQ') {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContent: 'main.vat_error_duplicatedHQ',
      type: MODAL_TYPE.ERROR
    }));
  } else if (resp.statusCode === 1899 && resp.data.translationKey === 'vatAddress.duplicatedVatAddress') {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContent: 'main.vat_error_duplicatedVatAddress',
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* deleteVatHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams?.resetReload);
    yield call(callbackParams?.deleteSuccess);
  } else if (resp.statusCode === 1899 && resp.data.translationKey === 'vatAddress.deleteMappedShop') {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContent: 'main.vat_error_deleteMappedShop',
      type: MODAL_TYPE.ERROR,
      onOk: () => {
        callbackParams.resetReload();
        callbackParams.deleteFail();
      }
    }));
  } else if (resp.statusCode === 1899 && resp.data.translationKey === 'vatAddress.deleteLastOneOrDefault') {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContent: 'main.vat_error_deleteLastOneOrDefault',
      type: MODAL_TYPE.ERROR,
      onOk: () => {
        callbackParams.resetReload();
        callbackParams.deleteFail();
      }
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        callbackParams.resetReload();
        callbackParams.deleteFail();
      },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchVatDefaultHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams?.resetReload);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchVatTaxesHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams?.resetReload);
    yield call(callbackParams?.taxesSuccess);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        callbackParams.resetReload();
        callbackParams.taxesFail();
        callbackParams.resetVatTaxesForm();
      },
      type: MODAL_TYPE.ERROR,
      clickClosable: false,
      escClosable: false
    }));
  }
}

export const vatSagas = {
  callVatAdd,
  getVatHandler,
  postVatHandler,
  patchVatHandler,
  deleteVatHandler,
  patchVatDefaultHandler,
  patchVatTaxesHandler,
  getVatAddHandler,
  watchers: [
    takeLatest(VAT_REQUEST_ID_LIST.CALL_VATADD, callVatAdd),
  ]
};


